import * as React from "react";
import { cn } from "../lib/utils";

const sizeClasses = {
  sm: "text-sm font-semibold",
  md: "text-base font-semibold",
  lg: "text-lg font-semibold",
} as const;

type SectionHeadingSize = keyof typeof sizeClasses;

interface SectionHeadingProps extends React.HTMLAttributes<HTMLElement> {
  size?: SectionHeadingSize;
  as?: "h2" | "h3" | "h4" | "span";
  children: React.ReactNode;
}

function SectionHeading({
  size = "md",
  as: Component = "span",
  className,
  children,
  ...props
}: SectionHeadingProps) {
  return (
    <Component className={cn(sizeClasses[size], "text-foreground", className)} {...props}>
      {children}
    </Component>
  );
}

export { SectionHeading };
export type { SectionHeadingProps, SectionHeadingSize };
